// Auto-refactored from translations.js on 2026-08-19
// Locale: it

const it = {
  wieMoeglich: { question: 'Come è possibile?', answer: 'Abbiamo ripensato la catena del valore.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'La via STIG ROCK',
    fazit: 'La filiera accorciata elimina le maggiori voci di costo.',
    fazitBigPre: 'Questo consente uno sconto fino al',
    fazitBigValue: '80%',
    steps: [ 'Miniera', 'Laboratorio di taglio', 'Certificazione', 'Cliente finale' ]
  },
  nav: { language: 'Lingua', contact: 'Contatto' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: "Un'opportunità unica",
    subtitle: 'Costruire patrimonio orientato al futuro.',
    description: 'STIG ROCK è una piattaforma internazionale che offre alle persone accesso a diamanti naturali, costruzione patrimoniale sostenibile e una community esclusiva.',
    scroll: 'Scorri per scoprire'
  },
  disclaimer: {
    overline: 'Nota Legale',
    title: 'Disclaimer',
    paragraphs: [
      "Questa presentazione ha esclusivamente scopo informativo e non costituisce consulenza finanziaria, d'investimento o fiscale.",
      'STIG ROCK non è un prodotto finanziario, ma si riferisce a diamanti naturali come beni tangibili.',
      "Non viene fornita alcuna garanzia per l'evoluzione del valore, i profitti o i rendimenti. I risultati passati non sono indicativi di risultati futuri.",
      'Tutti i calcoli presentati in relazione alle commissioni sono meramente esemplificativi e non costituiscono alcuna garanzia.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'COSTRUITO', 'SULLA STRUTTURA' ],
    body: 'STIG Group è un gruppo internazionale, costruito su chiarezza, responsabilità e valore a lungo termine. Ogni marchio, ogni iniziativa e ogni partnership segue un unico standard — senza scorciatoie, senza eccezioni.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'COSTRUITO', 'SULLA STRUTTURA' ],
        body: 'STIG Group è un gruppo internazionale, costruito su chiarezza, responsabilità e valore a lungo termine. Ogni marchio, ogni iniziativa e ogni partnership segue un unico standard — senza scorciatoie, senza eccezioni.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'IL MONDO', 'DEI DIAMANTI ESCLUSIVI' ],
        body: "STIG ROCK è un concetto moderno di STIG Group che unisce diamanti di alta qualità certificati GIA con strutture trasparenti e un'esperienza cliente esclusiva. Piani solutivi chiari, gestione professionale e orientamento internazionale."
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'COMMERCIO', 'INTERNAZIONALE DI DIAMANTI' ],
        body: 'STIG International fa parte di STIG Group ed è specializzato nel commercio internazionale di diamanti certificati GIA. Focus su qualità, fiducia e strutture commerciali moderne con partnership globali.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'RESPONSABILITÀ', 'DALLA MINIERA' ],
        body: "Ethical Mines rappresenta estrazione responsabile, provenienza tracciabile e diamanti conflict-free. Dalla miniera al mercato — documentazione completa per trasparenza, integrità e responsabilità a lungo termine lungo l'intera catena di fornitura."
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamanti',
    stigDrawback: 'Riserva di valore reale',
    overline: 'Opportunità',
    title: 'Opportunità per costruire patrimonio',
    subtitle: 'Metodi tradizionali a confronto.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex o Cripto',
        drawback: 'altamente speculativo, imprevedibile, complesso'
      },
      {
        tag: 'Azioni',
        name: 'Trading di Borsa',
        drawback: 'rischio di volatilità, conoscenze richieste, impegno di tempo'
      },
      {
        tag: 'Cripto',
        name: 'Trading',
        drawback: 'volatilità, rischio normativo, vulnerabilità di sicurezza'
      }
    ]
  },
  chance: {
    overline: 'Diamanti',
    title: "L'opportunità sottovalutata",
    body: "I diamanti sono da anni tra le forme d'investimento più stabili e promettenti, ma finora solo pochi hanno sfruttato questo potenziale.",
    callout: "Con il nostro STIG ROCK apriamo per la prima volta a tutti l'accesso a queste opportunità straordinarie."
  },
  wertentwicklung: {
    overline: 'Evoluzione del Valore 1995 — 2025',
    title: 'Una storia di valore.',
    usd: 'Dollaro USA',
    usdValue: '-49%',
    diamond: 'Diamanti',
    diamondValue: '+185%',
    note: 'Evoluzione dal 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Motivi Principali',
    title: 'Sei motivi per i diamanti',
    lead: 'I diamanti sono beni tangibili reali, che esistono indipendentemente da valute e sistemi finanziari — e conservano il loro valore da secoli.',
    items: [
      {
        n: '01',
        title: 'Stabilità a prova di crisi',
        body: 'Garanzia di bene tangibile. Indipendente da valute e sistemi finanziari.'
      },
      {
        n: '02',
        title: 'La massima mobilità',
        body: 'Piccoli, facili da nascondere e trasportare.'
      },
      {
        n: '03',
        title: 'Diversificazione & Scarsità',
        body: 'Carenza di offerta e limitazione naturale.'
      },
      { n: '04', title: 'Crescita a lungo termine', body: '+185% dal 1995.' },
      {
        n: '05',
        title: 'Trasparenza & Esclusività',
        body: 'Le 4 C come garanzia: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Riserva delle Case Reali',
        body: 'Persino le case reali utilizzano i diamanti come riserva patrimoniale.'
      }
    ]
  },
  markt: {
    overline: 'Volume di Mercato',
    title: '99 — 108 Mrd. USD',
    sub: 'Volume di scambi nel 2025',
    forecast: 'Previsione fino a ~2032 / 2034: ca. 140 – 168 Mrd. USD con crescita moderata (~4 – 5% annuo).',
    source: 'Fonte: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovazione',
    title: "Un'innovazione. Per la prima volta al mondo.",
    body: "STIG ROCK è la prima piattaforma al mondo che consente alle persone di generare un reddito passivo nel mercato dei diamanti, oltre all'apprezzamento del valore.",
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, EAU',
      'N. Registro DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: "Sull'Azienda",
    titleLines: [ 'STRUTTURA', 'INTERNAZIONALE', 'VISIONE CHIARA' ],
    body: 'STIG ROCK è stata fondata per rendere il mercato dei diamanti più trasparente, moderno e orientato al cliente — con focus su fiducia, sicurezza e struttura a lungo termine.'
  },
  sicherheit: {
    overline: 'Qualità & Sicurezza',
    title: 'Gemological Institute of America',
    body: 'Competenza certificata per i vostri diamanti. GIA valuta ogni pietra con massima precisione ed esperienza pluriennale — perizie di valore affidabili per la nostra azienda e i nostri clienti.',
    transparency: 'Ogni diamante soddisfa i più alti standard qualitativi ed è controllato e certificato da organizzazioni rinomate. Ogni pietra è unica e riceve un certificato individuale.',
    kimberley: 'Kimberley Process — lavoriamo esclusivamente con diamanti conflict-free.'
  },
  plaene: {
    overline: 'Solution Plan (SP)',
    title: "Un'innovazione di prodotto unica",
    sub: 'Sei Solution Plan graduali — da $1K a $100K+, ciascuno con sconto mensile crescente e per tutta la durata.',
    recommended: 'Popolare',
    oneYear: '1 anno',
    rowLabels: {
      delivery: 'Tempo di consegna',
      price: 'Prezzo Prodotto',
      carat: 'Carati',
      monthly: 'Sconto (Mensile)',
      totalDiscount: 'Sconto (Totale)',
      duration: 'Durata'
    },
    headers: {
      plan: 'Piano',
      from: 'Da',
      carat: 'Carati',
      monthly: 'Sconto / Mese',
      total: 'Sconto Totale',
      duration: 'Durata'
    },
    duration: '1 anno',
    footnote: 'Tutti i prezzi indicati sono senza garanzia e dipendono da qualità, domanda ed evoluzione attuale del mercato. I piani Solution sono disponibili anche per 2 anni.'
  },
  plaeneVIP: {
    overline: 'Solution Plan + Pacchetto VIP',
    title: 'Con il pacchetto VIP ancora più sconto',
    sub: 'Sconto Totale per piano – combinato con un pacchetto VIP ricevi da +1% a +3% in più, aumentando sensibilmente lo sconto totale.',
    rowLabels: {
      delivery: 'Tempo di consegna',
      price: 'Prezzo Prodotto',
      carat: 'Carati',
      monthly: 'Sconto (Mensile)',
      totalDiscount: 'Sconto (Totale)',
      vip1: 'Pacchetto VIP 1 (+1%)',
      vip2: 'Pacchetto VIP 2 (+2%)',
      vip3: 'Pacchetto VIP 3 (+3%)'
    },
    footnote: 'Tutti i prezzi indicati sono senza garanzia e dipendono da qualità, domanda ed evoluzione attuale del mercato.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Le tue opportunità',
    sub: 'Alla scadenza del tuo piano Solution puoi rivendere i tuoi diamanti a noi, oppure farli consegnare a casa.',
    options: [
      {
        key: 'deliver',
        title: 'Farsi consegnare',
        body: 'Diamanti (carati) al prezzo del tuo piano DS*'
      },
      {
        key: 'sellToUs',
        title: 'Vendere a noi',
        body: "Puoi rivendere i tuoi diamanti a noi al prezzo d'acquisto da te pagato."
      },
      {
        key: 'sellThirdParty',
        title: 'Vendere a terzi',
        body: 'Puoi rivendere i tuoi diamanti a terzi.'
      }
    ],
    footnote: '*DS-Plan sta per piano Solution.'
  },
  tradWeg: {
    overline: 'Commercio Tradizionale',
    title: 'Il modo tradizionale',
    sub: 'Prima che un diamante raggiunga il cliente finale, si creano notevoli margini commerciali attraverso intermediari, grossisti e dettaglianti, rispetto al prezzo del diamante grezzo dalla miniera.',
    steps: [
      { title: 'Miniera', subtitle: 'Diamanti grezzi' },
      { title: 'Intermediari', subtitle: 'Acquisto diamanti grezzi' },
      { title: 'Taglieria', subtitle: 'Taglio in diamanti da gioielleria' },
      { title: 'Certificazione', subtitle: 'da istituti riconosciuti come GIA' },
      { title: 'Borsa Diamanti', subtitle: 'Vendita al grossista' },
      { title: 'Grossista', subtitle: 'Vendita al dettaglio' },
      { title: 'Dettaglio', subtitle: 'es. gioiellerie' },
      { title: 'Cliente Finale', subtitle: 'Acquisto di diamanti' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'Il metodo STIG ROCK',
    sub: 'Interrompiamo questo ciclo acquistando i diamanti grezzi direttamente dalla miniera, facendoli tagliare e certificare dai nostri partner. In questo modo possiamo trasferire questi margini commerciali sotto forma di crediti sconto ai nostri clienti.',
    duration: '12 mesi – durata del piano DS',
    centerBig: '04',
    centerCaption: 'Fino a 4 cicli commerciali durante la durata del piano DS',
    cycle: [
      { n: '1.', title: 'Acquisto di più diamanti grezzi', body: 'per un piano DS' },
      { n: '2.', title: 'Tagliare e certificare', body: 'tramite i nostri partner' },
      { n: '3.', title: 'Vendita a clienti finali', body: 'e grossisti' },
      { n: '4.', title: 'Ripetere questo processo', body: "fino a 4× all'anno" }
    ],
    steps: [
      { title: 'Miniera', subtitle: 'Diamanti grezzi' },
      { title: 'Taglieria', subtitle: 'tramite i nostri partner' },
      { title: 'Certificazione', subtitle: 'da istituti riconosciuti' },
      { title: 'Cliente Finale', subtitle: 'Acquisto & crediti sconto' }
    ],
    footnote: '*DS-Plan sta per piano Solution.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Pacchetti VIP',
    sub: 'Validi per 12 mesi su tutti i piani Solution da te sottoscritti. A seconda del pacchetto VIP: da +1% a +3% di sconto aggiuntivo',
    cardKicker: 'in più – su tutti i',
    cardKicker2: 'piani Solution',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Dagli sconti ai risparmi',
      body: 'Risparmio mensile invece di esborso mensile. Dagli sconti nascono risparmi — e questi pagano esattamente le cose per cui altrimenti dovresti pagare ogni mese di tasca tua.',
      line1Label: 'Piano DS da',
      line1Value: '$5.000',
      line2Label: 'sconto mensile',
      line2Value: '3%',
      line3Label: 'Pacchetto VIP 3',
      line3Value: '+3%',
      resultLabel: 'risparmi mensili',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Come è possibile?',
    title: 'Abbiamo ripensato la catena del valore.',
    traditionalTitle: 'Il modo tradizionale',
    traditionalSteps: [
      'Miniera — Diamanti grezzi',
      'Intermediari — Acquisto',
      'Taglieria — Taglio',
      'Certificazione (GIA)',
      'Borsa Diamanti — Grossista',
      'Grossista → Dettaglio',
      'Gioiellerie → Cliente finale'
    ],
    traditionalNote: 'Prima che un diamante raggiunga il cliente finale, si creano notevoli margini commerciali attraverso intermediari, grossisti e dettaglianti.',
    stigTitle: 'Il metodo STIG ROCK',
    stigSteps: [
      'Acquisto diretto — Diamanti grezzi dalla miniera',
      'Tagliare & Certificare tramite i nostri partner',
      'Vendita a clienti finali & clienti B2B',
      "Fino a 4 cicli commerciali all'anno"
    ],
    stigNote: 'Interrompiamo il ciclo e trasferiamo i margini commerciali come crediti sconto ai nostri clienti — fino a 4 cicli commerciali durante la durata del piano DS.'
  },
  optionen: {
    overline: 'Le tue opportunità',
    title: 'Alla scadenza del tuo piano Solution',
    items: [
      { title: 'Farsi consegnare', body: 'Diamanti (carati) al prezzo del tuo piano DS.' },
      { title: 'Vendere a noi', body: "Rivendita al prezzo d'acquisto da te pagato." },
      { title: 'Vendere a terzi', body: 'Vendere i diamanti sul mercato libero.' }
    ]
  },
  einfacherWeg: {
    overline: "Piani Solution — un'innovazione di prodotto unica",
    title: 'Il modo semplice',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Registrazione',
        body: 'Contatta il tuo referente e crea un account gratuito!'
      },
      {
        n: '02',
        icon: 'cart',
        title: 'Acquisto di un prodotto',
        body: 'Già a partire da $250,-'
      },
      {
        n: '03',
        icon: 'discount',
        title: 'Ricevere sconti',
        body: 'Ricevi crediti sconto mensili.'
      }
    ]
  },
  business: {
    overline: 'Tipi di Bonus',
    title: 'Il modo più semplice e giusto.',
    sub: 'Cinque tipi di bonus — per il tuo successo aziendale.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Fino al livello 3, dalla qualifica Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Da Sapphire — infinitamente in profondità.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: "Sull'Infinity Bonus – fino al livello 5 · SENZA qualificazione."
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pool del fatturato mondiale.'
      },
      {
        name: 'Rank Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Bonus una tantum in diamanti (carati).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Questo bonus ti viene pagato per ogni nuovo piano Solution sottoscritto fino al 3° livello. Con requisiti molto bassi sblocchi i singoli livelli.',
    total: 'Fino al 18% Unilevel Bonus',
    levels: [
      {
        level: 'Livello 1',
        value: '10%',
        qual: "dall'inizio",
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Livello 2',
        value: '5%',
        qual: 'dalla qualifica Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Livello 3',
        value: '3%',
        qual: 'dalla qualifica Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: "Dalla qualifica Sapphire sei qualificato per il nostro piano Infinity Bonus. Ricevi il 3% di bonus. Con ogni nuova qualifica si aggiungono ulteriori punti percentuali. Se un partner nel tuo team è anch'esso qualificato, ricevi la differenza da grado a grado.",
    exampleTitle: 'Esempio',
    exampleRows: [
      { label: 'Tu sei Blue Diamond', value: '12%' },
      { label: 'Il tuo partner è Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Il tuo Infinity Bonus', value: '9%' },
    totalNote: 'Totale fino al 24% Infinity Bonus su tutti i piani Solution sottoscritti nel tuo team — infinitamente in profondità.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: "Con questo bonus benefici del successo del tuo team. Ricevi un Matching Bonus del 5% sull'Infinity Bonus dei tuoi partner — fino al 5° livello del tuo team.",
    note: "Su tutti i pagamenti Infinity Bonus nel tuo team – fino al 5° livello. Dall'inizio – SENZA qualificazione.",
    levels: [
      { level: 'Livello 1', value: '5%' },
      { level: 'Livello 2', value: '5%' },
      { level: 'Livello 3', value: '5%' },
      { level: 'Livello 4', value: '5%' },
      { level: 'Livello 5', value: '5%' }
    ],
    totalPrefix: 'Totale fino al',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: 'Il 3% del fatturato mondiale confluisce in parti uguali in 3 pool diversi. Raggiungendo determinate qualifiche ti qualifichi per ogni singolo pool.',
    forever: 'Una volta raggiunto – SEMPRE partecipe!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'da Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'da Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'da Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Totale',
    totalValue: '3%',
    totalSuffix: 'del fatturato mondiale'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rank Bonus',
    title: 'Rank Bonus',
    sub: 'Dalla qualifica Diamond ricevi un Rank Bonus. Questo viene pagato in diamanti (carati). Si tratta di un bonus una tantum.',
    highlight: 'Diamanti (carati) per un valore totale di',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Qualifiche di Carriera',
    title: 'Qualifiche di Carriera',
    sub: 'Per raggiungere le rispettive qualifiche di carriera conta il fatturato totale storico (HG). Dalla qualifica Sapphire deve essere distribuito su più team. Per raggiungere Ruby o superiore, necessiti di almeno due partner diretti con un piano Solution.',
    forever: 'Una volta raggiunto – SEMPRE confermato!',
    footnote: 'HV = Fatturato totale storico.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 partner diretti', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Inizia con noi',
    title: 'Il momento giusto è adesso.',
    body: "Questo modello di business stabilisce nuovi standard e unisce tutti i fattori di successo per un'attività sostenibile e di successo a lungo termine. Registrati oggi stesso, scegli il tuo piano Solution e cogli questa opportunità di business unica.",
    hint: 'Parla con la persona che ti ha invitato a questa presentazione — ha un link di registrazione per te.',
    formName: 'Nome',
    formEmail: 'E-Mail',
    formPhone: 'Telefono',
    formSubmit: 'Mettersi in contatto',
    success: 'Grazie — ti contatteremo in modo discreto e personale.',
    callCta: 'Chiama',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Nota Legale & Disclaimer',
    disclaimer: "Questa presentazione ha esclusivamente scopo informativo e non costituisce consulenza finanziaria, d'investimento o fiscale. STIG ROCK non è un prodotto finanziario, ma si riferisce a diamanti naturali come beni tangibili. Non viene fornita alcuna garanzia per l'evoluzione del valore, i profitti o i rendimenti. I risultati passati non sono indicativi di risultati futuri. Tutti i calcoli presentati in relazione alle commissioni sono meramente esemplificativi e non costituiscono alcuna garanzia. Modifiche ai contenuti riservate — traduzione libera (non traduzione ufficiale).",
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, EAU',
    copy: '© 2026 STIG International. Tutti i diritti riservati.',
    version: 'Versione: DS-12-2025 V3'
  },
  misc: { next: 'Sezione successiva' }
};

export default it;
